import { allAnimalRoutes } from "components/Signup/store/middlewares/utils/updateRoute";
import { parseUrl } from "../utils/parseUrlQuery";
import { useRouter } from "next/router";
import { StepName } from "components/Signup/steps/types";
import {
  selectAnimalById,
  useAllAnimals,
} from "components/Signup/store/selectors/animals";
import { useSignupStore } from "components/Signup/store/hooks";

export const useAnimalRouting = () => {
  const router = useRouter();
  const { stepName, animalId } = parseUrl(router.query);
  const animals = useAllAnimals();
  const { getState } = useSignupStore();

  const setDefaultAnimalIdOnRoute = () => {
    const newId = animals[0].id;

    const { step, ...query } = router.query;
    const { stepName: stepName2 } = parseUrl(router.query);

    return router.replace({
      pathname: `${stepName2}/${newId}`,
      query,
    });
  };

  if (allAnimalRoutes.includes(stepName as StepName)) {
    if (!animalId) {
      setDefaultAnimalIdOnRoute();
    } else {
      const animal = selectAnimalById(getState(), animalId);

      if (!animal) {
        setDefaultAnimalIdOnRoute();
      }
    }
  }
};
